import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalStore } from '../store';

export function useAppbarTitle(titleKey: string) {
	const { setPageTitle } = useGlobalStore();
	const { t } = useTranslation();

	useEffect(() => {
		setPageTitle(t(titleKey));
	}, [setPageTitle, t, titleKey]);
}
